import { getLocales } from '@change-corgi/config/locales';
import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_DASHBOARD_NEW_ASSETS = defineFcm('starter_dashboard_new_assets')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				locales: { type: 'array', shape: { type: 'enum', values: getLocales() } },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-axolotl',
		scope: ['corgi-front-end', 'monorail'],
		context: 'Petition share visuals new iteration',
		description: `Feature release flag that enables new share visuals generation for petitions.
		The petition service only uses the "enabled" value for determining whether to start creating new share visuals for petitions,
		while the frontend uses both "enabled" and the users "locale" to determine whether to show the UI.`,
		import: false,
		template: {
			enabled: true,
			locales: ['en-US'],
		},
	});
